import loadable from '@loadable/component';
import React, { Fragment, useState } from 'react';
import HeaderTitle, { HeaderTitleProps } from './HeaderTitle';

const LazySearchTakeover = loadable.lib(
    () => import('@eventbrite/search-takeover'),
);

const ExperimentBannerCTAOpensSearchScreen: React.FunctionComponent<
    HeaderTitleProps
> = ({ header }: HeaderTitleProps) => {
    const [isSearchTakeoverVisible, setIsSearchTakeoverVisible] = useState<
        null | boolean
    >(null);

    const headerProps = {
        ...header,
        customContentCtaLink: '/#search',
    };

    return (
        <Fragment>
            <HeaderTitle
                header={headerProps}
                clickCTASeasonal={() => setIsSearchTakeoverVisible(true)}
                fullbleed={true}
            />
            {isSearchTakeoverVisible !== null ? (
                <LazySearchTakeover>
                    {({ SearchTakeover }: { SearchTakeover: any }) => (
                        <SearchTakeover
                            domNodeId="root"
                            onClose={() => setIsSearchTakeoverVisible(false)}
                            id="search-takeover"
                            isVisible={isSearchTakeoverVisible}
                        />
                    )}
                </LazySearchTakeover>
            ) : null}
        </Fragment>
    );
};
export default ExperimentBannerCTAOpensSearchScreen;
